<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <v-card
        flat
        width="100%"
        class="verify-code">
        <v-card-text
          class="black--text px-0 mb-2">
          Revisa la bandeja de tu correo electrónico e ingresa
          el código de verificación de 6 dígitos para continuar.
        </v-card-text>
        <!-- verification code-->
        <ValidationProvider
          mode="eager"
          vid="verification_code"
          name="auth.verification_code"
          rules="required|digits:6"
          v-slot="{ errors }">
          <v-text-field
            filled
            flat
            :disabled="waiting"
            :maxlength="6"
            name="verificationCode"
            v-model="verificationCode"
            :error-messages="errors[0]"
            class="verification_code"
            label="Código de verificación"
            autocomplete="no"
            autofocus
            @keypress="filter($event)">
          </v-text-field>
        </ValidationProvider>
        <v-card-actions
          class="px-0">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="grey--text px-10"
            :disabled="waiting"
            @click="cancel">
            Cancelar
          </v-btn>
          <v-btn
            type="submit"
            class="brand-purple white--text px-10"
            :loading="waiting">
            Verificar
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </ValidationObserver>
</template>

<script>

import loginController from '@/controllers/Login';

export default {
  name: 'VerifyCode',
  props: {
    email: {
      default: null,
    },
    exists: {
      default: false,
    },
  },
  data() {
    return {
      waiting: false,
      verificationCode: null,
    };
  },
  methods: {
    cancel() {
      this.$emit('canceled');
    },
    // eslint-disable-next-line consistent-return
    filter(evt) {
      let event = evt;
      if (!event) {
        event = window.event;
      }
      const expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        event.preventDefault();
      } else {
        return true;
      }
    },
    submit() {
      this.waiting = true;
      const { email, verificationCode } = this;
      loginController.verifyCode(email, verificationCode)
        .then(() => {
          this.$emit('verified', verificationCode);
        })
        .catch((e) => {
          this.$error(e);
        })
        .then(() => {
          this.waiting = false;
        });
    },
  },
};
</script>

<style lang="scss">
.verify-code {
  .v-input.verification_code {
    input {
      font-size: 22px;
      font-weight: 500;
      letter-spacing: 5px;
    }
  }

  .v-messages__message {
    line-height: 15px;
  }
}
</style>
